module.exports = __webpack_public_path__ + "img/request-to-join/invite-teammates-53bc1149dbb5ec6ee7367237b3c8bd34.png";